const System = () => {
  return (
    <section id="sistema" className="content-section">
      <div className="card mb-3">
        <div className="card-body text-center">
          <h5 className="card-title">Sistema</h5>
        </div>

        <div className="card-body">
          <div className="card">
            <div className="card-body">
              <ol className="list-styled">
                <div>
                  <p className="mb-0">
                    <strong id="gerenciamento">Gerenciamento</strong>
                  </p>
                  <p>HTTP, HTTPS, SSH e VLAN</p>
                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Tempo de sessão</strong>
                        </p>
                      </li>

                      <div className="d-flex justify-content-center print-image img-container">
                        <img
                          src="./res/figures/tempo-sessao.png"
                          className="card-img-bottom img-md"
                          alt=""
                        />
                      </div>
                      <p>
                        Tempo máximo que o usuário pode ficar sem interagir com
                        o sistema. Quando o usuário ficar inativo, e a
                        contabilização do tempo configurado terminar, a sessão é
                        encerrada é o usuário deve logar novamente para acessar
                        o sistema.
                      </p>
                    </ul>

                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Acesso HTTP</strong>
                        </p>

                        <div className="d-flex justify-content-center print-image img-container">
                          <img
                            src="./res/figures/gerenciamento-http.png"
                            className="card-img-bottom img-xl"
                            alt=""
                          />
                        </div>
                        <ul className="p-xss-0 p-md-3 justified-text pt-0">
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Acesso via WAN: </strong>habilitar ao
                              equipamento via WAN.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>
                                Defesa contra ataque de Força Bruta:{" "}
                              </strong>
                              ativa a proteção contra ataques de força bruta.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Habilitado: </strong>marque para habilitar
                              o acesso via protocolo HTTP.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Porta: </strong>informe a porta para
                              aceitar conexões via protocolo HTTP (padrão 80).
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Acesso HTTPS</strong>
                        </p>

                        <div className="d-flex justify-content-center print-image img-container">
                          <img
                            src="./res/figures/gerenciamento-https.png"
                            className="card-img-bottom img-xl"
                            alt=""
                          />
                        </div>
                        <ul className="p-xss-0 p-md-3 justified-text pt-0">
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Acesso via WAN: </strong>habilitar ao
                              equipamento via WAN.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>
                                Defesa contra ataque de Força Bruta:{" "}
                              </strong>
                              ativa a proteção contra ataques de força bruta.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Porta: </strong>informe a porta para
                              aceitar conexões via protocolo HTTPS (padrão 443).
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Certificado/chave: </strong>selecione o
                              modo de reconhecimento de certificado/chave HTTPS.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Certificado: </strong>clique em Buscar
                              para localizar o certificado HTTPS a ser
                              utilizado.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Chave: </strong>clique em Buscar para
                              localizar a chave HTTPS a ser utilizada.
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>Acesso SSH</strong>
                        </p>

                        <div className="d-flex justify-content-center print-image img-container">
                          <img
                            src="./res/figures/gerenciamento-ssh.png"
                            className="card-img-bottom img-xl"
                            alt=""
                          />
                        </div>
                        <ul className="p-xss-0 p-md-3 justified-text pt-0">
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Habilitado: </strong>marque para habilitar
                              o acesso SSH ao equipamento.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>
                                Defesa contra ataque de Força Bruta:{" "}
                              </strong>
                              ativa a proteção contra ataques de força bruta.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Acesso via WAN: </strong>habilitar ao
                              equipamento via WAN.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Certificado/chave: </strong>selecione o
                              modo de reconhecimento de certificado/chave HTTPS.
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Porta: </strong>informe a porta para
                              aceitar conexões via protocolo SSH (padrão 22).
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Chave: </strong>clique em Buscar para
                              localizar a chave HTTPS a ser utilizada.
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <li>
                        <p className="mb-0 justified-text">
                          <strong>VLAN</strong>
                        </p>

                        <div className="d-flex justify-content-center print-image img-container">
                          <img
                            src="./res/figures/gerenciamento-vlan.png"
                            className="card-img-bottom img-xl"
                            alt=""
                          />
                        </div>
                        <ul className="p-xss-0 p-md-3 justified-text pt-0">
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>Interface: </strong>permite habilitar a
                              VLAN de gerência na interface Ethernet
                            </p>
                          </li>
                          <li>
                            <p className="mb-0 justified-text">
                              <strong>VLAN de gerência: </strong>defne a VLAN de
                              gerência do equipamento.
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </ul>
                </div>

                <div>
                  <p className="mb-0">
                    <strong id="backup">Backup e Restauração</strong>
                  </p>
                  <p className="justified-text">
                    Backup e restauração ao padrão de Fábrica.
                  </p>

                  <div className="d-flex justify-content-center print-image img-container">
                    <img
                      src="./res/figures/backup-restauracao.png"
                      className="card-img-bottom img-xl"
                      alt=""
                    />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text">
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Criar arquivo de backup: </strong>irá fazer
                        download do arquivo que contém as configurações atuais
                        do produto.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Aplicar configurações já salvas: </strong>
                        permite restaurar as configurações salvas a partir de um
                        arquivo de backup.
                      </p>
                      <p className="mb-0 justified-text">
                        <strong>Obs.: </strong>A restauração do backup deve ser
                        feita a partir de um arquivo gerado da mesma versão do
                        dispositivo que vai ser restaurado "Ex.: backup da
                        versão 4.4.13 restaurado no dispositivo com a versão
                        4.4.13". Ao realizar a restauração através de arquivos
                        de diferentes versões a{" "}
                        <strong>
                          restauração por completo não é garantida.
                        </strong>
                        A restauração entre diferentes versões{" "}
                        <strong>não é aconselhada e não deve ser feita.</strong>
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>
                          <a
                            href="#reset-padrao-fabrica"
                            style={{ color: "#00A335" }}
                          >
                            Restaurar padrão de fábrica:
                          </a>
                        </strong>
                        <a href="#reset-padrao-fabrica">
                          redefine as configurações do equipamento ao padrão de
                          fábrica.
                        </a>
                      </p>
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-0">
                    <strong id="atualizacao-firm">
                      Atualização de Firmware
                    </strong>
                  </p>
                  <p className="justified-text">
                    Permite atualizar a versão de firmware do equipamento.
                  </p>

                  <div className="d-flex justify-content-center print-image img-container">
                    <img
                      src="./res/figures/atualizacao-firmware.png"
                      className="card-img-bottom img-xl"
                      alt=""
                    />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text">
                    <ul className="p-xss-0 p-md-3 justified-text">
                      <ul className="p-xss-0 p-md-3 justified-text">
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>
                              Atualização automática (via cronos):{" "}
                            </strong>{" "}
                            caso seja lançada uma versão mais atual o
                            dispositivo ira apresentar uma notificação para que
                            possa atualizar a versão de seu sistema.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Atualização manual: </strong> selecione o
                            arquivo da versão de firmware a ser instalada e
                            clique em "Atualizar". Aguarde até que o processo de
                            atualização seja concluído.
                          </p>
                        </li>
                      </ul>
                    </ul>
                  </ul>
                </div>

                <div>
                  <p className="mb-0">
                    <strong id="inccloud">
                      Integração INC Cloud
                    </strong>
                  </p>
                  <p className="justified-text">
                    Permite ativar / desativar a conexão com o gerenciador INC Cloud, bem como desassociar o equipamento do gerenciador.
                  </p>

                  <div className="d-flex justify-content-center print-image img-container">
                    <img
                      src="./res/figures/inccloud.png"
                      className="card-img-bottom img-xl"
                      alt=""
                    />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text">
                    <ul className="p-xss-0 p-md-3 justified-text">
                      <ul className="p-xss-0 p-md-3 justified-text">
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>
                              Comunicação com o INC Cloud:
                            </strong>{" "}
                            Permite ativar ou desativar a comunicação com o INC Cloud.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Código de desvinculação: </strong> Informe o código de verificação e clique em "Enviar" para desassociar o produto do INC Cloud.
                            Para obter o código de desassociação, acesse a página "Sistema - Desvinculação de dispositivos" no INC Cloud.
                            Caso a comunicação com o INC Cloud estiver desativada, não será possível desvincular o dispositivo
                          </p>
                        </li>
                        <p className="mb-0 justified-text">
                          <strong>Obs.: </strong>Caso o dispositivo esteja vinculado ao INC Cloud,
                          um banner será exibido orientando a evitar alterações de configuração,
                          para evitar conflitos entre a configuração local e a do gerenciador.
                        </p>
                      </ul>
                    </ul>
                  </ul>
                </div>

                <div>
                  <p className="mb-0">
                    <strong id="log">Log</strong>
                  </p>
                  <p className="justified-text">
                    A ferramenta Log de sistema oferece informações de depuração
                    sobre os serviços e protocolos do sistema. Se ocorrer
                    qualquer tipo de mau funcionamento do equipamento, as
                    mensagens aqui registradas, podem ajudar os administradores
                    da rede a identificar e resolver o problema.
                  </p>

                  <div className="d-flex justify-content-center print-image img-container">
                    <img
                      src="./res/figures/log.png"
                      className="card-img-bottom img-xl"
                      alt=""
                    />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text">
                    <ul className="p-xss-0 p-md-3 justified-text">
                      <ul className="p-xss-0 p-md-3 justified-text">
                        <p className="mb-0 justified-text">
                          <strong>Nível: </strong> permite-se selecionar o nível
                          de informação que será exibida no log, sendo:
                          <li>
                            {" "}
                            <strong>Nível 3: </strong>Error - error conditions
                          </li>
                          <li>
                            {" "}
                            <strong>Nível 4: </strong>Warning - warning
                            conditions
                          </li>
                          <li>
                            {" "}
                            <strong>Nível 6: </strong>Info - informational
                            messages
                          </li>
                          <li>
                            {" "}
                            <strong>Nível 7: </strong>Debug - debug-level
                            message
                          </li>
                        </p>
                      </ul>
                      <p className="mb-0 justified-text">
                        <strong>Servidor Remoto: </strong> é possível enviar as
                        informações do Log do sistema para um servidor remoto de
                        sua preferência. Deve ser informado o nome FQDN (Fully
                        Qualified Domain Name) do servidor e também a porta do
                        servidor. (A porta-padrão é a 514 que envia via
                        protocolo UDP).
                      </p>
                    </ul>
                  </ul>
                </div>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default System;
